import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LoadingButton from '../../App/common/layout/LoadingButton';
import { getDay, getMonth, format, parseISO } from 'date-fns';
import ClockTimeSevenOutline from '../../App/common/icons/ClockTimeSevenOutline';
import TimeTable from '../../App/common/icons/TimeTable';
import NoteEdit from '../../App/common/icons/NoteEdit';
import CalendarMonth from '../../App/common/icons/CalendarMonth';
import Stop from '../../App/common/icons/Stop';

const NEWDATE = new Date();
const DAYS = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];

export default function ActivitiesWidget(props) {
  const {
    auth,
    history,
    loading,
    materis,
    tugass,
    latihans,
    tess,
    sjadwal,
    sactivities,
    snotes,
    skalender,
    total,
    getActivities,
    handleLink,
  } = props;

  const [daynow, setDaynow] = useState(0);
  const [monthnow, setMonthnow] = useState(0);

  let jadwal = sjadwal.jadwal;
  let kelass = sjadwal.kelass;
  let pelajarans = sjadwal.pelajarans;
  let gurus = sjadwal.gurus;


  useEffect(() => {
    setDaynow(getDay(NEWDATE));
    let rawMonth = getMonth(NEWDATE) + 1;
    let month = rawMonth < 10 ? '0' + rawMonth : rawMonth;
    setMonthnow(month);
  }, []);

  useEffect(() => {
    getActivities(auth, history);
  }, [auth, getActivities, history]);

  let kelas =
    kelass?.[0] &&
    kelass.find((k) => k.id + '' === auth.active_kelas + '')?.title;

  let detailJadwal = jadwal?.description && JSON.parse(jadwal.description);

  let filterJadwal =
    detailJadwal?.[0] &&
    detailJadwal.map((j) => {
      return {
        id: j.id,
        no: j.no,
        day: j.day,
        jp: j.jp,
        kelas,
        startTime: j.startTime,
        endTime: j.endTime,
        ap: j[kelas + '_ap'],
        guru: j[kelas + '_guru'],
      };
    });

  let rawSchedule =
    filterJadwal?.[0] && filterJadwal.filter((j) => j.day === DAYS[daynow]);
  let schedule = rawSchedule?.[0]
    ? rawSchedule
    : [{ id: 1, subject: 'no schedule' }];

  let events = skalender?.events && JSON.parse(skalender.events);
  let filterEvents =
    events?.[0] &&
    events.filter((e) => {
      let startMonth = e.startDate && e.startDate.split('/')[1];
      let endMonth = e.endDate && e.endDate.split('/')[1];
      if (startMonth === monthnow || endMonth === monthnow) {
        return e;
      }
      return null;
    });

  return (
    <BodyCardHeader handleLink={handleLink}>
      {loading && (
        <div
          className='flex justify-center align-center'
          style={{
            height: 128,
          }}
        >
          <LoadingButton />
        </div>
      )}
      {!loading && <TotalContent handleLink={handleLink} total={total} />}
      <NavPanel
        materis={materis}
        tugass={tugass}
        latihans={latihans}
        tess={tess}
        schedule={schedule}
        pelajarans={pelajarans}
        gurus={gurus}
        daynow={daynow}
        sactivities={sactivities}
        snotes={snotes}
        filterEvents={filterEvents}
      />
    </BodyCardHeader>
  );
}

function BodyCardHeader({ children, handleLink }) {
  return (
    <div className='column is-full fadein'>
      <div className='card ml-2 mr-2 mb-2 mt-2'>
        <header
          className='card-header has-background-white has-text-danger hand-pointer'
          onClick={() => handleLink('/aktivitas-belajar')}
        >
          <div className='custom-card-flex is-size-6' style={{ width: '100%' }}>
            <p>
              <span className='flex justify-start align-center'>
                <TimeTable size={18} color={'#f24667'} />
                <span className='ml-1'>Aktivitas Belajar</span>
              </span>
            </p>
          </div>
        </header>
        <div className='card-content'>{children}</div>
      </div>
    </div>
  );
}

function TotalContent({ total, handleLink }) {
  return (
    <div className='flex justify-around my-3 pb-3'>
      <TitleItem
        icon={'clock-time'}
        color={'#0277fb'}
        handleLink={handleLink}
        content={'jadwal'}
        total={total}
      />
      <TitleItem
        icon={'timetable'}
        color={'#fb3b2d'}
        handleLink={handleLink}
        content={'aktivitas-belajar'}
        total={total}
      />
      <TitleItem
        icon={'noteedit'}
        color={'#2cce8a'}
        handleLink={handleLink}
        content={'notes'}
        total={total}
      />
      <TitleItem
        icon={'calendar-month'}
        color={'#5757cf'}
        handleLink={handleLink}
        content={'kalender'}
        total={total}
      />
    </div>
  );
}

function TitleItem({ handleLink, content, icon, color }) {
  let displayIcon = <></>;
  if (icon === 'clock-time') {
    displayIcon = <ClockTimeSevenOutline size={36} color={color} />;
  }
  if (icon === 'timetable') {
    displayIcon = <TimeTable size={36} color={color} />;
  }
  if (icon === 'noteedit') {
    displayIcon = <NoteEdit size={36} color={color} />;
  }
  if (icon === 'calendar-month') {
    displayIcon = <CalendarMonth size={36} color={color} />;
  }
  return (
    <div
      onClick={() => handleLink(`/${content}`)}
      className={`hand-pointer flex flex-column px-1 py-1`}
    >
      <div className='flex justify-center'>{displayIcon}</div>
      <div className='flex justify-center' style={{color}}>
        <span className='ml-1 is-capitalized'>{content?.split('-')?.[0]}</span>
      </div>
    </div>
  );
}

function NavPanel({
  materis,
  tugass,
  latihans,
  tess,
  schedule,
  pelajarans,
  gurus,
  daynow,
  monthnow,
  sactivities,
  snotes,
  filterEvents,
}) {
  const [initial, setInitial] = useState({
    activeTab: 'jadwal',
  });

  const handleClickTab = (e, val) => {
    e.preventDefault();
    setInitial({
      ...initial,
      activeTab: val,
    });
  };

  return (
    <nav className='panel' style={{ boxShadow: 'none' }}>
      <p className='panel-tabs'>
        <PanelTab
          key={'jadwal'}
          initial={initial}
          handleClickTab={handleClickTab}
          content={'jadwal'}
        />
        <PanelTab
          key={'aktivitas-belajar'}
          initial={initial}
          handleClickTab={handleClickTab}
          content={'aktivitas-belajar'}
        />
        <PanelTab
          key={'notes'}
          initial={initial}
          handleClickTab={handleClickTab}
          content={'notes'}
        />
        <PanelTab
          key={'kalender'}
          initial={initial}
          handleClickTab={handleClickTab}
          content={'kalender'}
        />
      </p>
      {initial.activeTab === 'jadwal' && schedule?.[0] && (
        <>
          {!schedule.length && <NoContent content={'jadwal'} />}
          {schedule[0] && (
            <PanelBlock
              key={'bjadwal'}
              items={schedule}
              content={'jadwal'}
              pelajarans={pelajarans}
              gurus={gurus}
              daynow={daynow}
            />
          )}
        </>
      )}
      {initial.activeTab === 'aktivitas-belajar' && sactivities?.items && (
        <>
          {!sactivities?.items?.[0] && (
            <NoContent content={'aktivitas-belajar'} />
          )}
          {sactivities?.items[0] && (
            <PanelBlock
              key={'baktivitas'}
              items={sactivities?.items}
              content={'aktivitas-belajar'}
            />
          )}
        </>
      )}
      {initial.activeTab === 'notes' && snotes?.items && (
        <>
          {!snotes?.items?.[0] && <NoContent content={'notes'} />}
          {snotes?.items[0] && (
            <PanelBlock
              key={'bnotes'}
              items={snotes?.items}
              content={'notes'}
            />
          )}
        </>
      )}
      {initial.activeTab === 'kalender' && filterEvents && (
        <>
          {!filterEvents?.length && <NoContent content={'kalender'} />}
          {filterEvents[0] && (
            <PanelBlock
              key={'bkalender'}
              items={filterEvents}
              content={'kalender'}
            />
          )}
        </>
      )}
      <br />
    </nav>
  );
}

function PanelTab({ initial, handleClickTab, content }) {
  return (
    <a
      onClick={(e) => handleClickTab(e, content)}
      href='/dashboard'
      className={`${
        initial.activeTab === content
          ? 'is-active has-text-success'
          : 'has-text-grey'
      }`}
    >
      <span className='is-capitalized is-size-6 has-text-weight-semibold'>
        {content?.split('-')?.[0]}
      </span>
    </a>
  );
}

function PanelBlock({ items, content, pelajarans, gurus, daynow }) {
  return (
    <>
      {['aktivitas-belajar', 'notes'].includes(content) &&
        items?.[0] &&
        items.map((i, key) => {
          if (key === 5) {
            return (
              <Link
                to={`/${content}`}
                className='panel-block is-italic'
                key={i.id + i.title}
              >
                more...
              </Link>
            );
          }
          if (key > 5) {
            return null;
          }
          return (
            <Link
              to={`/${content}/${i.id}`}
              className='panel-block pl-4 has-text-grey'
              key={i.id}
              style={{ fontSize: 13 }}
            >
              {key + 1}. {i.title} {content === 'notes' ? i?.date && format(parseISO(i.date), ' - dd LLL yyyy') : ''}
            </Link>
          );
        })}
      {content === 'jadwal' &&
        items?.[0] &&
        items.map((i, key) => {
          let codeActivity = i?.ap;

          let titleActivity =
            pelajarans?.[0] &&
            pelajarans.find((p) => p.code === codeActivity)?.title;

          if (items?.[0]?.subject === 'no schedule')
            return (
              <NoContent key={items?.[0]?.id} content='Jadwal' />
            );

          if (items.length - 1 === key && (!i?.ap || i?.ap === ''))
            return <></>;

          if (!titleActivity && !i?.ap) return <></>;

          return (
            <Fragment key={key}>
              <table className='table is-narrow' style={{ margin: 4 }}>
                <tbody>
                  <tr>
                    <td
                      style={{ width: 120, fontSize: 13, textAlign: 'center' }}
                    >
                      <span>
                        {i?.startTime} - {i?.endTime}
                      </span>
                    </td>
                    <td style={{ fontSize: 13 }}>
                      <span>{titleActivity ?? i?.ap}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <hr style={{ margin: 0, borderWidth: 1 }} />
            </Fragment>
          );
        })}
      {content === 'kalender' &&
        items?.[0] &&
        items.map((i, key) => {
          if (key === 5) {
            return (
              <Link
                to={`/${content}`}
                className='panel-block is-italic'
                key={i.id}
              >
                more...
              </Link>
            );
          }
          if (key > 5) {
            return null;
          }

          function fDate(dateString) {
            const [yy, mm, dd] = dateString?.split('/');

            const formattedDate = format(
              new Date(yy, parseInt(mm) - 1, dd),
              'd MMMM yyyy'
            );
            return formattedDate;
          }

          return (
            <div
              className='panel-block pl-4 has-text-grey'
              key={i.id}
              style={{ fontSize: 13 }}
            >
              <Stop
                size={24}
                color={i?.type === 'libur' ? '#f24667' : 'grey'}
              />
              <span className='ml-2'>
                {i?.startDate && fDate(i?.startDate)}{' '}
                {i?.endDate && ` - ${fDate(i?.endDate)}`} {i?.subject}
              </span>
            </div>
          );
        })}
    </>
  );
}

function NoContent({ content }) {

  return (
    <div className='panel-block has-text-grey' style={{ fontSize: 13, paddingLeft: 16 }}>
      Tidak Ada {content}
    </div>
  );
}
